export default from './DesktopMessages';



// WEBPACK FOOTER //
// ./src/components/LoanOfficerMessages/components/DesktopMessages/index.js